import { FC } from 'react';
import { Box } from '@mafc/trolly';
import { DrawerTitle } from './AvailablePromotionsDrawer.style';
import { useTranslation } from 'react-i18next';

const AvailablePromotionsHeader: FC = () => {
  const { t } = useTranslation();

  return (
    <DrawerTitle>
      <Box fontSize={6} textAlign="center">
        {t('promo.selectVoucher')}
      </Box>
    </DrawerTitle>
  );
};

export default AvailablePromotionsHeader;
